export const forceTranscriptToEndOfAnnotationList = (config) => {
    const { annotations } = config;
    const transcript = annotations.find(annotation => annotation.target === '#player_transcript');
    const annotationsNoTranscript = annotations.filter(annotation => annotation.target !== '#player_transcript'); 
    if (!transcript) {
        return config;
    }

    return {
        ...config,
        annotations: [
            ...annotationsNoTranscript,
            transcript
        ]
    }
}
